import {hasPermission} from "../../../utils/permission-matcher.js";
import {DEV_LOGIN, isDevMenuEnabled} from "./dev-menu.js";

export const sessionToContext = (session) => ({
    permissions: session?.permissions ?? [],
    hasCortex: !!session?.hasCortex,
    hasDispatch: !!session?.hasDispatch,
    celeparEnabled: !!session?.celeparEnabled,
    system: !!session?.system,
    vmsCards: Array.isArray(session?.vmsCards) ? session.vmsCards : [],
    login: session?.login,
    boName: session?.bo_name,
    ecapAcronym: session?.ecap_acronym,
    devEnabled: isDevMenuEnabled(),
});

const CORTEX = "sentry.search.cortex";
const CELEPAR = "sentry.search.celepar";
const DISPATCH_IDS = ["dispatch", "bo", "dashboard"];

const isVisibleForTarget = (node, target) =>
    target === "dispatch" ? !node.hide_dispatch : !node.hide_web;

const isDevVisible = (ctx) => ctx.system && (ctx.login === DEV_LOGIN || !!ctx.devEnabled);

const isVisible = (node, ctx, target) => {
    if (node.hide) return false;
    if (!isVisibleForTarget(node, target)) return false;
    if (!node.permissions) return true;

    if (node.id && DISPATCH_IDS.includes(node.id) && !ctx.hasDispatch) return false;
    if (node.id === "dev" && !isDevVisible(ctx)) return false;

    const tokens = String(node.permissions).split(",").map((t) => t.trim()).filter(Boolean);
    for (const token of tokens) {
        if (hasPermission(ctx.permissions, token)) {
            if (token.includes(CORTEX)) return ctx.hasCortex;
            if (token.includes(CELEPAR)) return ctx.celeparEnabled;
            return true;
        }
    }
    return false;
};

const applyLabel = (node, ctx) => {
    switch (node.id) {
        case "myUser": return {...node, name: ctx.login ?? node.name};
        case "bo": return {...node, name: ctx.boName ?? node.name};
        case "ecap": return {...node, name: ctx.ecapAcronym ?? node.name};
        case "bos-tags": return {...node, name: `Marcadores de ${ctx.boName}`};
        default: return node;
    }
};

const isEmptyGroup = (node) =>
    Array.isArray(node.items) && node.items.length === 0 && (!node.url || node.url === "#");

export const buildMenu = (nodes, ctx, target) => {
    if (!Array.isArray(nodes)) return [];

    return nodes
        .filter((node) => isVisible(node, ctx, target))
        .map((node) => {
            const labeled = applyLabel(node, ctx);
            if (!Array.isArray(node.items)) return labeled;
            return {...labeled, items: buildMenu(node.items, ctx, target)};
        })
        .filter((node) => !isEmptyGroup(node));
};

export const withVmsCards = (list, vmsCards) => {
    const base = Array.isArray(list) ? list : [];
    if (!Array.isArray(vmsCards) || vmsCards.length === 0) return base;
    return [...base, ...vmsCards];
};

export const injectVmsCardsIntoCards = (tree, vmsCards) => {
    if (!Array.isArray(tree) || !Array.isArray(vmsCards) || vmsCards.length === 0) return tree;
    if (!Array.isArray(tree[0]?.items)) return tree;
    const [first, ...rest] = tree;
    return [{...first, items: withVmsCards(first.items, vmsCards)}, ...rest];
};
